import { makeStyles } from '@mui/styles';
import {
  body1,
  heading1,
  heading2,
  heading3,
} from '../../../shared/theme/text.styles';
const appBarHeight = 88;
const heroHeightBig = '960px';
const heroHeightSmall = '90vh';

export const useHeroStyles = makeStyles((theme) => ({
  hero: {
    position: 'relative',
    width: '100vw',
    maxWidth: '100%',
    marginTop: `${appBarHeight * -1}px`,
    height: heroHeightBig,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingLeft: '88px',
    paddingBottom: '140px',
    zIndex: 0,
    color: '#121212',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    [theme.breakpoints.down('lg')]: {
      paddingLeft: '60px',
      paddingBottom: '120px',
      height: heroHeightSmall,
    },

    [theme.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
      paddingBottom: '40px',
    },
  },

  tagline: {
    ...heading1,

    [theme.breakpoints.down('md')]: {
      ...heading2,
    },

    [theme.breakpoints.down('sm')]: {
      ...heading3,
    },
  },

  welcome: {
    ...body1,
  },

  imageSlider: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    height: heroHeightBig,
    '--divider-color': 'rgba(0, 0, 0, 1)',
    transition: 'transform 0.2s',

    '&:hover': {
      '.handles': {
        transform: 'scale(1.2)',
      },
    },

    [theme.breakpoints.down('lg')]: {
      height: heroHeightSmall,
    },

    '& .bg-img': {
      width: '100%',
      height: heroHeightBig,
      objectFit: 'cover',

      [theme.breakpoints.down('lg')]: {
        height: heroHeightSmall,
      },
    },
  },

  overlay: {
    zIndex: 0,
    position: 'absolute',
    background: `linear-gradient(180deg, rgba(20, 0, 116, 0.5) 7.81%, rgba(0, 0, 0, 0) 80.73%)`,
    width: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  text: {
    zIndex: 1,
    background: 'white',
    width: 'fit-content',
    padding: '20px',
    borderRadius: '4px',
  },
}));
